import * as React from 'react';

export class TextAzureRenderer extends React.Component {
	constructor(props) {
		super(props);		
		this.state = {
			blockType: this.props.info.blockType
		};
	}

	dragStart_Handler(event) {
		var block = JSON.parse(event.target.dataset.block);
		event.dataTransfer.setData("Block", JSON.stringify(block));
	}
	render() {
		if (!this.props.info.documentJson || this.props.info.mode === "View" || this.props.info.mode === "AssignVendor") {
			return <div id="divBlocks" style={{ whiteSpace: "nowrap", position: "relative", height: 1350 }}></div>;
		}
		const offsetTop = this.props.info.invoiceDocument.offsetTop;
		const offsetLeft = this.props.info.invoiceDocument.offsetLeft;
		const offsetWidth = this.props.info.invoiceDocument.offsetWidth;
		const offsetHeight = this.props.info.invoiceDocument.offsetHeight;

		var that = this;
		
		

		return (
			<div id="divBlocks" style={{ position: "relative", height: offsetHeight === 0 ? 1350 : offsetHeight }}>
				{
					
					this.props.info.documentJson.filter(function (block) {
						return block.blockType.value === that.state.blockType.value && block.page === that.props.info.page;
					}).map(function (block, index) {
						

						let dpiWidth = offsetWidth;
						let dpiHeight = offsetHeight;
						let left = (block.geometry.boundingBox.left * (dpiWidth));
						let top = (block.geometry.boundingBox.top * (dpiHeight));
						let width = Math.abs((block.geometry.boundingBox.width * dpiWidth) - left);
						let height = Math.abs((block.geometry.boundingBox.height * dpiHeight) - top);

						let backgroundColor = "";
						let blockType = that.state.blockType;

						if (that.props.info.invoiceModelEditor) {
							var invoiceModelEditor = Object.entries(that.props.info.invoiceModelEditor);

							invoiceModelEditor.map(function (i, index) {
								if (i.length === 2 && i[1] !== null && i[1] !== undefined && i[1].blocks !== undefined && i[1].blocks.length > 0) {
									var item = i[1].blocks.find(b => b.id === block.id);

									if (item) {
										backgroundColor = "yellow";
									}
								}
							});
						}
						let borderColor = "#ff00ff";
						switch (block.blockType.value) {
							case 'KEY_VALUE_SET': {
								switch (block?.entityTypes[0]) {
									case 'KEY': {
										borderColor= "#ff00ff"
										break;
									}
									case 'VALUE': {
										borderColor = "#ffd900"
										break;
									}
								}
								break;
							}
						}

						return <div
							draggable="true"
							id={block.id}
							key={index}
							data-text={block.content ? block.content : ""}
							data-block={JSON.stringify(block)}
							dragleft={left}
							dragtop={top}
							onDragStart={that.dragStart_Handler}
							style={{
								border: 1,
								borderStyle: "solid",
								borderColor: borderColor,
								borderRadius: 2,
								backgroundColor: backgroundColor,
								opacity: 0.5,
								display: blockType.value === block.blockType.value ? "" : "none",
								position: "absolute",
								width: width,
								height: height,
								left: left,
								top: top
							}}>
						</div>;
					
					})
				}
			</div>
		);
	}
}